var Vendd = (function (Vendd) {
    'use strict';

    var pending = false;


    Vendd.MessageBus.subscribe(Vendd.Recipe.Messages.GetModel, Vendd.Recipe, function (envelope) {

        if (pending === true) {
            return false;
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Recipe, new Vendd.Recipe.Messages.GetModelSuccess(response));

            pending = false;
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Recipe, new Vendd.Recipe.Messages.GetModelFailure(response));
        }

        var itemId = envelope.message.data.itemId;
        var path = envelope.message.data.path;
        if (itemId === undefined) {
            itemId = LhApp.Context.Item.Id;
            path = LhApp.Context.Item.Path;
        }

        var options = {
            data: { itemId: itemId, itemPathChecksum: path, attributes: envelope.message.data.attributes || [], currencyCode: LhApp.Context.Currency.Code, languageCode: LhApp.Context.Language, roleCode: envelope.message.data.roleCode },
            url: 'ProductRecipeService.svc/GetProductRecipes',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        pending = true;

        Vendd.Service.call(options);
    });


    return Vendd;

})(Vendd || {});